import * as types from 'store/modules/hress3u/mutation-types'
import hress3u from 'api/hress3u'
import swal from 'sweetalert'
import hress3uLabels from 'assets/labels/hress3u'
import { hress3uColumns } from 'assets/columns/hress3u'
import configLabel from 'src/../config/label'
import { constLabels } from 'assets/js/constLabels.js'
import * as dashTypes from 'store/modules/dash/mutation-types'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hress3uLabels,
    columns: hress3uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab2: {
        table: {
          total: 0,
          rows: []
        }
      }
    },
    approve: {},
    indexSelected: [],
    detailSubmit: {
      tab1: {}
    }
  },
  getters: {
    [types.GET_HRESS3U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRESS3U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRESS3U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRESS3U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRESS3U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRESS3U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRESS3U_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRESS3U_DETAIL_SUBMIT] (state) {
      return state.detailSubmit
    }
  },
  mutations: {
    [types.SET_HRESS3U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRESS3U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRESS3U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].columnsTab1 = configLabel.replaceLabelToColumns(state.columns[keyLang].columnsTab1, labels[keyLang])
        state.columns[keyLang].columnsTab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].columnsTab2, labels[keyLang])
      }
    },
    [types.SET_HRESS3U_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRESS3U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRESS3U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRESS3U_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRESS3U_DETAIL_SUBMIT] (state, data) {
      state.detailSubmit = data
    }
  },
  actions: {
    [types.TOGGLE_HRESS3U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRESS3U_INDEX_DISP, indexDisp)
      commit(types.SET_HRESS3U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRESS3U_COLUMNS_LABELS] ({ commit }) {
      hress3u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS3U_COLUMNS, data.labels)
          commit(types.SET_HRESS3U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS3U_INDEX] ({ commit }, searchParams) {
      hress3u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS3U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS3U_DETAIL] ({ commit }, detailParams) {
      hress3u.getDetail(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS3U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESS3U_DETAIL_SUBMIT] ({ commit }, detailParams) {
      hress3u.getDetailSubmit(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESS3U_DETAIL_SUBMIT, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRESS3U_SEND_APPROVE] ({ commit, dispatch }, params) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          let referenceButton = params.referenceButton
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hress3u.postSendApprove(params.approveParams)
          .then((response) => {
            const data = JSON.parse(response.request.response)
            dispatch(types.RECEIVED_HRESS3U_INDEX, {})
            dispatch(dashTypes.RECEIVED_HEADER_NOTI_TOTAL, 'P,Y,N,A')
            swal({title: '', text: data.response, html: true, type: 'success'}, function () {
              referenceButton.click()
            })
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hress3u/index.js